import SlugOrComments from './[authorOrSlug]/[slugOrComments]';

export default SlugOrComments;
